import { forwardRef, ReactNode, ComponentType } from 'react';

interface TippyDropDownContentProps {
  children?: ReactNode;
  className?: string;
}

export const TippyDropDownContent = ({ children, className = '' }: TippyDropDownContentProps) => {
  return <div className={`tippy-dropdown-content bg-light border border-gray-300 ${className}`}>{children}</div>;
};

interface TippyDropDownProps {
  text?: string;
  className?: string;
  Component?: ComponentType | null;
  disabled?: boolean;
}

export const TippyDropDown = forwardRef<HTMLButtonElement, TippyDropDownProps>(function TippyDropDown(
  { text = '', className = '', Component = null, disabled = false },
  ref
) {
  return (
    <button
      className={`btn-tippy-dropdown form-control-sm d-flex border bg-white justify-content-between align-items-center ${className}`}
      disabled={disabled}
      ref={ref}
    >
      {typeof Component === 'function' ? (
        <Component />
      ) : (
        <>
          {text}
          <i className="ms-2 fa-regular fa-angle-down" />
        </>
      )}
    </button>
  );
});
